import GenerateApplicationsReportModal from './sidebarComponents/GenerateApplicationsReportModal';
import ApplicationsSendMessagesModal from './sidebarComponents/ApplicationsSendMessagesModal';
import ApplicationsSendAgreementsToDGCSModal from './sidebarComponents/ApplicationsSendAgreementsToDGCSModal';


export const getSidebarActions = () => [
  {
    component: GenerateApplicationsReportModal,
    name: 'genereate'
  },
  {
    component: ApplicationsSendMessagesModal,
    name: 'send'
  },
  {
    component: ApplicationsSendAgreementsToDGCSModal,
    name: 'send_to_dgcs'
  }
];
